/* global axios */
import ApiClient from './ApiClient';

class OrderConfigurationsAPI extends ApiClient {
  constructor() {
    super('order_configurations', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, { order_field_visibility: data });
  }
}

export default new OrderConfigurationsAPI();
